export default __webpack_public_path__ + "static/media/2324.7e1e442a.png";